import { AiOutlineEdit } from "react-icons/ai";
import { SalonAdminSvg } from "../../../assets/SVGs/SVGs";

type Props = { data: any };
const TeamMemberWorkingLocations = ({ data }: Props) => {
  return (
    <div className="bg-white p-4 rounded-lg grid items-center">
      <div className="flex items-center justify-between mb-4 ">
        <h3 className="text-color-primary text-xl font-semibold">
          Working Locations
        </h3>
        <AiOutlineEdit className="text-[#9999A7] flex items-center text-lg justify-center text-center " />
      </div>
      <div className="flex items-center gap-4">
        {data?.locations?.map((e: any) => {
          return (
            <div className="bg-[#EEF0FF] py-3 px-4 gap-3 rounded-lg flex items-center text-sm w-fit">
              <span className="flex items-center justify-center">
                {SalonAdminSvg}
              </span>
              <span>{e.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamMemberWorkingLocations;
